import {useEffect, useState} from 'react';
import {useMediaQuery} from 'react-responsive';
import {useLocation} from 'react-router-dom';

export const useSearchHeaderCompact = () => {
    const location = useLocation();
    const isDesktop = useMediaQuery({query: '(min-width: 1150px)'});

    const [isCompact, setIsCompact] = useState(false);

    useEffect(() => {
        const isSearchPage = location.pathname.startsWith('/search');

        if (!isDesktop || !isSearchPage) {
            setIsCompact(false);
            return;
        }

        let lastScrollY = window.scrollY;
        const delta = 5;
        const minScrollToHide = 50;

        const handleScroll = () => {
            const current = window.scrollY;

            if (current > lastScrollY + delta && current > minScrollToHide) {
                // Скролл вниз — прячем хедер
                setIsCompact(true);
            } else if (current < lastScrollY - delta) {
                // Скролл вверх — показываем только когда доскроллили до самого верха
                if (current <= minScrollToHide) {
                    setIsCompact(false);
                }
            }

            lastScrollY = current;
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isDesktop, location.pathname]);

    return isDesktop ? isCompact : false;
};
